module.exports = __webpack_public_path__ + "static/media/home-section-2.904407dd.png";